import { useSpacingBetweenProductCard } from '@/hooks';

import ProductPlaceholder from '../Product/ProductPlaceholder';
import { Slider } from '../Slider';

const ProductsSkeleton = () => {
  const {
    breakpoints,
    defaultSlidePerView,
    defaultSpaciBetween,
    spacing_between_card,
    isProductCardLargImage,
  } = useSpacingBetweenProductCard();

  return (
    <Slider
      activatedHover
      breakpoints={breakpoints}
      centeredSlides={false}
      className="products__carousel"
      freeMode
      isNotPaddingMobile={spacing_between_card === 'none'}
      showSliderCardLink={true}
      slidesPerView={defaultSlidePerView}
      spaceBetween={defaultSpaciBetween}
    >
      {Array.from({ length: 20 }).map((_, index) => (
        <ProductPlaceholder key={index} largeCard={isProductCardLargImage} />
      ))}
    </Slider>
  );
};

export { ProductsSkeleton };
